import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        chatId: Number,
    };

    start(event) {
        event.preventDefault();
        event.stopPropagation();

        const deleteChatModalController = this.application.getControllerForElementAndIdentifier(
            document.getElementById('delete-conversation-modal'),
            'delete-chat-modal'
        );

        deleteChatModalController.chatIdValue = this.chatIdValue;
        deleteChatModalController.show();
    }
}
